import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#fb5004",
      contrastText: "#fff"
    }
  }
})

export default theme
